import ServiceExec from '@/common/utils/ServiceExec';

class LabSvc extends ServiceExec {
    getLatestLabResearchData(params = {}) {
        return this.queryPost('/api/app/lab/getLatestLabResearchData', params)
        .then(res => res.data);
    }

    getLabResearchList(params = {}) {
        return this.queryPost('/api/app/lab/getLabResearchList', params)
        .then(res => res.data);
    }

    requestResearch(params = {}) {
        return this.queryPost('/api/app/lab/requestResearch', params)
        .then(res => res.data)
    }

    requestChange(params = {}) {
        return this.queryPost('/api/app/lab/requestChange', params)
        .then(res => res.data)
    }

    getRequireInfo(params = {}) {
        return this.queryPost('/api/app/lab/getRequireInfo', params)
        .then(res => res.data)
    }

    requestPerformance(params = {}) {
        return this.queryPost('/api/app/lab/requestPerformance', params)
        .then(res => res.data)
    }
}

export default new LabSvc();
